/* @flow */

import type { Action } from '../types'

export const NOOP: string = 'opinary/NOOP'

export function noopAction(): Action {
  return {
    type: NOOP,
  }
}



// WEBPACK FOOTER //
// ./src/stores/noop.js